import { ParsedUrlQueryInput } from 'querystring';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { Paths } from 'utils/paths';

export const buildQueryParams = (params: Record<string, unknown>) => {
  const queryParams = Object.entries(params).reduce((acc, current, index) => {
    const prefix = index > 0 ? '&' : '';
    const [key, value] = current;

    if (value === undefined) return acc;

    const encodedValue = encodeURI(String(value));

    return `${acc}${prefix}${key}=${encodedValue}`;
  }, '');

  return queryParams;
};

interface ResolvePathParams {
  pathname: string;
  query?: ParsedUrlQueryInput;
}

export const resolvePath = (route: ResolvePathParams) => {
  const { pathname, query = {} } = route;

  const urlParams = pathname.match(/\[(.*?)\]/g) || [];
  let newUrlPath = pathname;
  const remainingQuery: Record<string, any> = { ...query };

  urlParams.forEach(param => {
    const paramName = param.slice(1, -1);
    const paramValue = String(query[paramName]);

    newUrlPath = newUrlPath.replace(param, encodeURI(paramValue));
    delete remainingQuery[paramName];
  });

  const queryString = buildQueryParams(remainingQuery);

  if (queryString) newUrlPath += `?${queryString}`;

  return newUrlPath;
};

interface DoesRouteMatchParams {
  signature: string;
  route: string | null;
}

export const doesRouteMatch = (params: DoesRouteMatchParams) => {
  const { signature, route } = params;

  const signatureParams = signature.match(/\[(.*?)\]/g) || [];
  let newSignaturePath = signature;

  signatureParams.forEach(param => {
    newSignaturePath = newSignaturePath.replace(param, `([^/]+)`);
  });

  const regex = new RegExp(`^${newSignaturePath}$`);

  return regex.test(String(route));
};

interface DownloadURLParams {
  url: string;
  fileName?: string;
}

export const downloadURL = async (params: DownloadURLParams) => {
  const { url, fileName } = params;

  const response = await axios.get(url, { responseType: 'blob' });

  saveAs(response.data, fileName);
};

export const isKioskPath = (pathname: string) => {
  return pathname.startsWith(Paths.KIOSK);
};
